module.exports = __webpack_public_path__ + "c7cba15da9575ddf555f9d9d2dc969c4.svg";